module.exports = __webpack_public_path__ + "img/ic_order_result.96a685c9.png";